<script>
import PaxTotalsBase from './paxTotalsBase.vue'
export default {
  page() {
    return {
      title: 'Destination Report',
      meta: [
        {
          name: 'description',
          content: ``,
        },
      ],
    }
  },
  components: { PaxTotalsBase },
  data() {
    return {
      routeKey: 'alldest',
      key1: 'TotalBrd',
      key2: 'Destination',
      key2plural: 'Destinations',
      sortKey: 'value',
    }
  },
}
</script>

<template>
  <PaxTotalsBase
    :route-key="routeKey"
    :key1="key1"
    :key2="key2"
    :key2plural="key2plural"
    :sort-key="sortKey"
  />
</template>
